import { JSResourceForInteraction } from '@atlassian/react-async';
// eslint-disable-next-line import/order
import { createEntryPoint } from '@atlassian/react-entrypoint';
// eslint-disable-next-line import/order
import type { EntryPoint, EntryPointComponent } from 'react-relay';
// eslint-disable-next-line import/order
import type { OperationType } from 'relay-runtime';
import type { NewMoreMenuPopupProps } from '../../../common/types';

type PopupEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	Record<string, never>,
	NewMoreMenuPopupProps,
	Record<string, never>
>;

export const popupEntryPoint: EntryPoint<
	PopupEntryPointComponent,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction<PopupEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_global-more-menu-content-entrypoint" */ './index',
		{
			moduleId: 'global-more-menu-content-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
